<p-accordion
    #accordion
    value="0"
>
    <p-accordion-panel value="0" [disabled]="tabsDisabled">
        <p-accordion-header>Invoice Setup</p-accordion-header>
        <p-accordion-content>
            <p-toolbar>
                <button
                    icon="pi pi-external-link"
                    pButton
                    #updateMultiple
                    label="Multi-Update"
                    title="Update multiple invoice setup records"
                    [disabled]="
                        !(SelectInvoiceOptionsSubject.asObservable() | async) ||
                        !(
                            SelectInvoiceOptionsSubject.asObservable()
                            | async
                            | isArray
                        ) ||
                        (SelectInvoiceOptionsSubject.asObservable() | async)
                            ?.length < 2
                    "
                ></button>
                <p-toggleButton
                    #showHideAddress
                    [(ngModel)]="displayAddress"
                    [onLabel]="'Hide Address'"
                    [offLabel]="'Show Address'"
                    [ngModelOptions]="{ standalone: true }"
                ></p-toggleButton>
                <p-toggleButton
                    #showHideFooter
                    [(ngModel)]="displayFooter"
                    [onLabel]="'Hide Custom Options'"
                    [offLabel]="'Show Custom Options'"
                    [ngModelOptions]="{ standalone: true }"
                ></p-toggleButton>
                <!-- <div>
                    <ef-column-search [elements]="elements"></ef-column-search>
                </div> -->
            </p-toolbar>
            <div [ngStyle]="{ height: invoiceHeight(), width: '100%' }">
                <ef-invoice
                    [items]="invoices"
                    [addresses]="addresses"
                    [remitAddresses]="remitAddresses"
                    [billingAddresses]="billingAddresses"
                    [accountClassProperties]="accountClassProperties"
                    [signatureLineProperties]="signatureLineProperties"
                    [invoiceViewOptions]="invoiceViewOptions"
                    [disclaimerProperties]="disclaimerProperties"
                    [paymentTermsProperties]="paymentTermsProperties"
                    [contracts]="invoiceContracts"
                    [chargeNumbers]="chargeNumbers"
                    [types]="invoiceTypes"
                    [displayAddress]="displayAddress"
                    [displayFooter]="displayFooter"
                    (SelectItem)="SelectInvoiceOptionsSubject.next($event)"
                    (SaveItem)="
                        SaveInvoiceOptions.next($event);
                        SelectInvoiceOptionsSubject.next([])
                    "
                    (CancelItem)="SelectInvoiceOptionsSubject.next([])"
                    (PassElements)="onGetElements($event)"
                ></ef-invoice>
            </div>
        </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="1" [disabled]="tabsDisabled">
        <p-accordion-header>Voucher Setup</p-accordion-header>
        <p-accordion-content>
            <button
                icon="pi pi-external-link"
                pButton
                #updateMultipleSessions
                label="Multi-Update"
                title="Update multiple invoice voucher records"
                [disabled]="
                    !(SelectVoucherOptionsSubject.asObservable() | async) ||
                    (SelectVoucherOptionsSubject.asObservable() | async)
                        ?.length === 0
                "
            ></button>
            <div [ngStyle]="{ height: voucherHeight() }">
                <ef-invoice-session
                    [items]="sessions"
                    [addresses]="addresses"
                    [remitAddresses]="remitAddresses"
                    [billingAddresses]="billingAddresses"
                    [contracts]="invoiceSessions"
                    (SelectItem)="SelectVoucherOptionsSubject.next($event)"
                    (SaveItem)="SaveSession.next($event)"
                ></ef-invoice-session>
            </div>
        </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="2" [disabled]="tabsDisabled">
        <p-accordion-header>Custom Options</p-accordion-header>
        <p-accordion-content>
            <div [ngStyle]="{ height: tabHeight }">
                <ef-invoice-selections
                    [invoiceProperties]="invoiceProperties"
                    [items]="selections"
                    (SaveItem)="SaveSelection.next($event)"
                    (DeleteItem)="DeleteSelection.next($event)"
                ></ef-invoice-selections>
            </div>
        </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="3">
        <p-accordion-header>Address Options</p-accordion-header>
        <p-accordion-content>
            <div [ngStyle]="{ height: tabHeight }">
                <ef-invoice-address
                    [states]="states"
                    [addressTypes]="addressTypes"
                    [items]="addressSetup"
                    (SaveItem)="SaveAddress.next($event)"
                    (DeleteItem)="DeleteAddress.next($event)"
                ></ef-invoice-address>
            </div>
        </p-accordion-content>
    </p-accordion-panel>
    <!-- <p-accordionTab [disabled]="tabsDisabled" header="Invoice Setup" value="0">
        <p-toolbar>
            <button
                icon="pi pi-external-link"
                pButton
                #updateMultiple
                label="Multi-Update"
                title="Update multiple invoice setup records"
                [disabled]="
                    !(SelectInvoiceOptionsSubject.asObservable() | async) ||
                    !(
                        SelectInvoiceOptionsSubject.asObservable()
                        | async
                        | isArray
                    ) ||
                    (SelectInvoiceOptionsSubject.asObservable() | async)
                        ?.length < 2
                "
            ></button>
            <p-toggleButton
                #showHideAddress
                [(ngModel)]="displayAddress"
                [onLabel]="'Hide Address'"
                [offLabel]="'Show Address'"
                [ngModelOptions]="{ standalone: true }"
            ></p-toggleButton>
            <p-toggleButton
                #showHideFooter
                [(ngModel)]="displayFooter"
                [onLabel]="'Hide Custom Options'"
                [offLabel]="'Show Custom Options'"
                [ngModelOptions]="{ standalone: true }"
            ></p-toggleButton>
            <div>
                <ef-column-search [elements]="elements"></ef-column-search>
            </div>
        </p-toolbar>
        <div [ngStyle]="{ height: invoiceHeight(), width: '100%' }">
            <ef-invoice
                [items]="invoices"
                [addresses]="addresses"
                [remitAddresses]="remitAddresses"
                [billingAddresses]="billingAddresses"
                [accountClassProperties]="accountClassProperties"
                [signatureLineProperties]="signatureLineProperties"
                [invoiceViewOptions]="invoiceViewOptions"
                [disclaimerProperties]="disclaimerProperties"
                [paymentTermsProperties]="paymentTermsProperties"
                [contracts]="invoiceContracts"
                [chargeNumbers]="chargeNumbers"
                [types]="invoiceTypes"
                [displayAddress]="displayAddress"
                [displayFooter]="displayFooter"
                (SelectItem)="SelectInvoiceOptionsSubject.next($event)"
                (SaveItem)="
                    SaveInvoiceOptions.next($event);
                    SelectInvoiceOptionsSubject.next([])
                "
                (CancelItem)="SelectInvoiceOptionsSubject.next([])"
                (PassElements)="onGetElements($event)"
            ></ef-invoice>
        </div>
    </p-accordionTab>
    <p-accordionTab [disabled]="tabsDisabled" header="Voucher Setup" value="1">
        <button
            icon="pi pi-external-link"
            pButton
            #updateMultipleSessions
            label="Multi-Update"
            title="Update multiple invoice voucher records"
            [disabled]="
                !(SelectVoucherOptionsSubject.asObservable() | async) ||
                (SelectVoucherOptionsSubject.asObservable() | async)
                    ?.length === 0
            "
        ></button>
        <div [ngStyle]="{ height: voucherHeight() }">
            <ef-invoice-session
                [items]="sessions"
                [addresses]="addresses"
                [remitAddresses]="remitAddresses"
                [billingAddresses]="billingAddresses"
                [contracts]="invoiceSessions"
                (SelectItem)="SelectVoucherOptionsSubject.next($event)"
                (SaveItem)="SaveSession.next($event)"
            ></ef-invoice-session>
        </div>
    </p-accordionTab>
    <p-accordionTab [disabled]="tabsDisabled" header="Custom Options" value="2">
        <div [ngStyle]="{ height: tabHeight }">
            <ef-invoice-selections
                [invoiceProperties]="invoiceProperties"
                [items]="selections"
                (SaveItem)="SaveSelection.next($event)"
                (DeleteItem)="DeleteSelection.next($event)"
            ></ef-invoice-selections>
        </div>
    </p-accordionTab>
    <p-accordionTab header="Address Options" value="3">
        <div [ngStyle]="{ height: tabHeight }">
            <ef-invoice-address
                [states]="states"
                [addressTypes]="addressTypes"
                [items]="addressSetup"
                (SaveItem)="SaveAddress.next($event)"
                (DeleteItem)="DeleteAddress.next($event)"
            ></ef-invoice-address>
        </div>
    </p-accordionTab> -->
</p-accordion>
